import BaseEvent from "./BaseEvent";
export default class BPMEvent extends BaseEvent {
    constructor(beat, bpm, index) {
        super();
        this._BEAT_END = Number.POSITIVE_INFINITY;
        this._LENGTH = Number.POSITIVE_INFINITY;
        this._MS_PER_BEAT = 0;
        this.TIME_END = Number.POSITIVE_INFINITY;
        this.PRIORITY = 0;
        this.BEAT = beat;
        this.BPM = bpm;
        this.INDEX = index;
    }
    get BPM() {
        return this._BPM;
    }
    set BPM(val) {
        this._BPM = val;
        this._MS_PER_BEAT = 60000 / val;
    }
    get MS_PER_BEAT() {
        return this._MS_PER_BEAT;
    }
    get MS_PER_ROW() {
        return this._MS_PER_BEAT / 48;
    }
    get BEAT_LENGTH() {
        return this._LENGTH;
    }
    set BEAT_LENGTH(val) {
        this._LENGTH = val;
        this._BEAT_END = this.BEAT + val;
    }
    get BEAT_END() {
        return this._BEAT_END;
    }
    set BEAT_END(val) {
        this._BEAT_END = val;
        this._LENGTH = this._BEAT_END - this.BEAT;
    }
}
